// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const dedenne: PokeData = {
  "id": 702,
  "name": "dedenne",
  "height": 2,
  "weight": 22,
  "base_experience": 151,
  "types": [
    PokeType.ELECTRIC,
    PokeType.FAIRY
  ],
  "api_moves": [
    "tackle",
    "tail-whip",
    "thunder-shock",
    "thunder-wave",
    "thunder",
    "rest",
    "super-fang",
    "snore",
    "charm",
    "charge",
    "discharge",
    "charge-beam",
    "entrainment",
    "volt-switch",
    "parabolic-charge",
    "play-rough",
    "nuzzle"
  ],
  "moves": [
    "tackle",
    "thunder-shock",
    "thunder",
    "volt-switch",
    "play-rough",
    "zap-cannon",
    "moonblast",
    "heal-bell",
    "thunderbolt",
    "sweet-kiss",
    "thunder-fang",
    "electric-wrath",
    "guardian-bond"
  ],
  "evolution_chain": {
    "id": 360,
    "item": null,
    "species": [
      {
        "name": "dedenne",
        "order": 702,
        "types": [
          PokeType.ELECTRIC,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 105,
    "speed": 164,
    "ability_power": 131
  },
  "stat_changes": [],
  "catch_rate": 180,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
